/**
 * Organization Client
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const OrganizationMemberRole = {
    Member: 'Member',
    Admin: 'Admin'
} as const;
export type OrganizationMemberRole = typeof OrganizationMemberRole[keyof typeof OrganizationMemberRole];

